import { render, staticRenderFns } from "./reassignStaffModal.vue?vue&type=template&id=4013fd4c&"
import script from "./reassignStaffModal.vue?vue&type=script&lang=js&"
export * from "./reassignStaffModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4013fd4c')) {
      api.createRecord('4013fd4c', component.options)
    } else {
      api.reload('4013fd4c', component.options)
    }
    module.hot.accept("./reassignStaffModal.vue?vue&type=template&id=4013fd4c&", function () {
      api.rerender('4013fd4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/appointments/components/reassignStaffModal.vue"
export default component.exports